import axios from "axios";

export const AuthToken = (axios.defaults.headers.common[
	"x-id-token"
] = sessionStorage.getItem("user_id"));
